import {isEmpty} from "../../helpers/object";

const NoteManagerConfig = {
    willRenderData: false, // Will the data be rendered out as JSON via the `get` function.
    notRenderedContent: ' ', // The content to render out when the date is not rendered.
}

export class NoteManager {

    static async fetchCart() {
        return window.fetch('/cart.js', {
            method: 'GET',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'}
        })
            .then((response) => response.json())
            .catch((error) => {
                throw new Error(error)
            });
    }

    constructor(goCart) {
        this.goCart = goCart;
        this.data = {};
    }

    async fetchServerNote() {
        let cartJson = await NoteManager.fetchCart();
        return cartJson['note'];
    }

    async fetchData() {
        let serverNote = await this.fetchServerNote();
        let serverData = {};
        try {
            serverData = JSON.parse(serverNote);
        } catch (e) {
            console.error("[NoteManager] Could not parse note JSON: ", serverNote);
        }
        return serverData;
    }

    async setForKey(key, value) {
        this.data = await this.fetchData();
        if (!this.data) this.data = {};
        if (this.data?.hasOwnProperty(key)) {
            if (typeof value === 'undefined' || value === null || value === '') {
                delete this.data[key]
            } else {
                this.data[key] = value;
            }
        } else {
            if (!(typeof value === 'undefined' || value === null || value === '')) {
                this.data[key] = value;
            }
        }
    }

    get() {
        if (NoteManagerConfig.willRenderData == false) return NoteManagerConfig.notRenderedContent; // When configured to not render the data we will return a whitespace char. Hopefully this whitespace is enough to "trick" Shopify into considering that there is a note (even though it's blank).
        if (!this.data || isEmpty(this.data)) return '';
        return JSON.stringify(this.data);
    }
}
